module.exports = __webpack_public_path__ + "img/vertical_4_1_7042.ffd1c306.png";